var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGreenUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_59206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53596 3.91096C6.79224 3.65468 7.20776 3.65468 7.46404 3.91096L11.839 8.28596C12.0953 8.54224 12.0953 8.95776 11.839 9.21404C11.5828 9.47032 11.1672 9.47032 10.911 9.21404L7 5.30308L3.08904 9.21404C2.83276 9.47032 2.41724 9.47032 2.16096 9.21404C1.90468 8.95776 1.90468 8.54224 2.16096 8.28596L6.53596 3.91096Z",
    fill: "#52C41A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_59206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenUp);
export default __webpack_public_path__ + "static/media/arrow-green-up.0acb4308.svg";
export { ForwardRef as ReactComponent };